import gql from "graphql-tag";
const invokeCalcQuery = gql(` 
query invokeCalc($event: AWSJSON!) {
  invokeCalc(event: $event) {
    status
  }
}
`)
export default invokeCalcQuery;
